import gql from 'graphql-tag'

export const queryTranslations = gql`
query listContentTranslations($contentId: ID, $languageId: ID) {
	cashAssist {
			listContentTranslations(filter: {
				contentId: $contentId,
				languageId: $languageId

			}) {
				items {
					id
					translation
					contentType
					contentId
					language {
						id
						locale
					}
				}
			}
	}
}
`
export const queryLanguages = gql`
query listContentTranslationLanguages {
	cashAssist {
		listContentTranslationLanguages {
			items {
				id
				locale
			}
		}
	}
}
`
export const mutateContentTranslations = gql`
mutation setContentTranslations($records: [NewContentTranslation!]!) {
	cashAssist {
			setContentTranslations(records: $records) {
			id
			translation
			contentType
			contentId
			language {
				id
				locale
			}
		}
	}
}
`
